import { app, dispatch } from "hf-rt";
import { myBag, customer, cart } from "../models";


const initialState = {
  signed: false,
  user: "",
  isLoginComplete: false
};

export default {
  name: "login",
  actions: {
    fetchUser: async function(isCheckoutPage, isProductDetailsPage) {
      dispatch({ type: "FETCH_USER" });
      dispatch({ type: "LOGIN_START" });
      const options = {
        credentials: "include"
      };

      window.isLogin = false;

      try {
        const data = await fetch(app.getURL({ api: "login" }), options);
        if (data.status === 200) {
          dispatch({ type: "NOT_LOGGED_IN" });
          throw new Error("NOT_LOGGED_IN");
        } else if (data.status === 201) {
          window.isLogin = true; // 在window記錄登入狀態
          dispatch({ type: "SIGNED_IN" });
          customer.actions.fetchCustomer(); //for user email verification
          if (!isCheckoutPage) {
            // 不是Checkout頁面的才再去發 miniCart API
            cart.actions.fetchCart();
          }
        } else {
          throw new Error();
        }
      } catch (error) {
        dispatch({ type: "NOT_LOGGED_IN" });
        const secondData = await fetch(app.getURL({ api: "login" }), options);
        if (secondData.status === 200) {
          dispatch({ type: "NOT_LOGGED_IN" });
          // Insider Event
          if (window.insider_object) {
            const user = {
              gdpr_optin: true,
              custom: {
                pushnami_subscribers_id:
                  localStorage.pushnamiSubscriberId || undefined,
                publisher_id: localStorage.Publisher_Id || undefined
              }
            };
            window.insider_object.user = user;
          }
        } else if (secondData.status === 201) {
          window.isLogin = true; // 在window記錄登入狀態
          dispatch({ type: "SIGNED_IN" });
          customer.actions.fetchCustomer(); //for user email verification
          if (!isCheckoutPage) {
            // 不是Checkout頁面的才再去發 miniCart API
            cart.actions.fetchCart();
          }
        } else {
          dispatch({ type: "NOT_LOGGED_IN" });
          throw new Error();
        }
      } finally {
        dispatch({ type: "LOGIN_END" });
        if (!isProductDetailsPage) {
          // 不是ProductDetails頁面的才再去發 myBag API
          myBag.actions.fetchMyBag();
        }
      }
    }
  },
  reducers: function(state = initialState, action) {
    switch (action.type) {
      case "NOT_LOGGED_IN":
        return { ...state, signed: false };
      case "SIGNED_IN":
        return { ...state, signed: true };
      case "LOGIN_START":
        return { ...state, isLoginComplete: false };
      case "LOGIN_END":
        return { ...state, isLoginComplete: true };
      default:
        return state;
    }
  }
};
